import { useSimilarRecords } from "@/core/common/hooks/useSimilarRecords";
import { isSimilarName, searchTermsFor } from "@/core/common/utils/similarity";
import type { SimilarRecordItem } from "@/ui/SimilarRecordsHint";
import type { ClientEntity } from "../types/ClientEntity";
import { getClientEntities } from "./useGetClientEntities";

export const useSimilarClientEntities = (
  name = "",
  zoneId?: string,
): SimilarRecordItem[] => {
  const { matches } = useSimilarRecords<ClientEntity>({
    key: `clientEntities:${zoneId}`,
    terms: searchTermsFor(name),
    fetchCandidates: async (term) =>
      (await getClientEntities(zoneId, 1, 20, true, term)).data,
    getId: (clientEntity) => clientEntity.id,
    match: (clientEntity) =>
      isSimilarName(name, clientEntity.name) ? ["name"] : [],
    enabled: !!zoneId,
  });

  return matches.map(({ item, reasons }) => ({
    id: item.id,
    title: item.name,
    reasons,
    enabled: item.enabled,
  }));
};
